import { useMutation } from '@tanstack/react-query';

type CustomDataItem = {
  field_id: number;
  content: string;
};

type BulkUpdateCompanyCustomFieldsRequest = {
  ids: number[];
  custom_data: CustomDataItem[];
};

export default function useBulkUpdateCompanyCustomFields() {
  const token = (document.getElementsByName('csrf-token')[0] as HTMLMetaElement).content;
  return useMutation({
    mutationFn: async (params: BulkUpdateCompanyCustomFieldsRequest) => {
      const response = await fetch('/agent/api/companies/bulk_update_custom_fields', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-CSRF-Token': token,
        },
        body: JSON.stringify(params),
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.error || 'カスタムフィールドの更新に失敗しました');
      return data;
    },
  });
}
